module.exports = __webpack_public_path__ + "1f66501d79ad9db2949d61d4efaf11bd.MP3";